import { useHookstate, type State } from "@hookstate/core";
import { Grid } from "@mui/material";
import React from "react";
import FilterAutocompleteFetch from "~/components/FilterAutocompleteFetch";
import FilterAutocompleteWarehouse from "~/components/FilterAutocompleteWarehouse";
import FilterTextField from "~/components/FilterTextField";
import useUserState from "~/features/User/stores/UserState";
import { useLang } from "~/hooks/useLang";

interface WarehouseCheckoutResponsiblesProps {
  readonly warehouseId: State<number | null>
  readonly userId: State<number | null>
}

export default function WarehouseCheckoutResponsibles({ warehouseId, userId }: WarehouseCheckoutResponsiblesProps) {
  const { translate } = useLang();
  const { user } = useUserState();


  return (
    <Grid container xs={12} spacing={2} marginBottom={2}>
      <Grid item xs={3}>
        <FilterTextField
          currentText={`${user().get().registration} - ${user().get().representation_name}`}
          label={'Location'}
          disabled={true}
          hideEndAdornment={true}
          onTextFieldChange={() => { }}
        />
      </Grid>
      <Grid item xs={3}>
        <FilterAutocompleteWarehouse
          warehouseId={warehouseId.get()}
          onWarehouseChange={(warehouse) => warehouseId.set(warehouse)}
          warehouseByUser={true}
        />
      </Grid>
      <Grid item xs={3}>
        <FilterAutocompleteFetch
          label={translate('User')}
          urlFetch={'/user/get'}
          dataRequest={'user'}
          size={'small'}
          disabled={false}
          onFetchChange={(user: number | null) => userId.set(user)}
          valueId={userId.get() ? Number(userId.get()) : undefined}
        />
      </Grid>
    </Grid>
  )
}